export default __webpack_public_path__ + "static/media/utracker.7382a776.jpg";